import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAcceptVatReportDisclaimer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const result = await apiClient.user.acceptVatReportDisclaimer.mutation();
      if (result.status !== 200) throw result.body;
      return result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-profile'] });
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error accepting VAT report disclaimer');
    },
  });
};
